<template>
  <ui-content title="Programación - Guías">
    <ui-card>
      <div class="row form-row align-items-center">
        <div class="col-lg-3">
          <div class="form-group">
            <label class="form-label">Módulo</label>
            <select class="form-control form-control-sm" v-model="form.idModule">
              <option :value="1">Pool</option>
              <option :value="2">Machu Picchu Brasil</option>
            </select>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="form-group">
            <label class="form-label">Mes</label>
            <date-picker
                input-class="form-control form-control-sm"
                v-model="form.month"
                type="month"
                placeholder="Selecciona el mes"
                format="MM-YYYY"
                value-type="YYYY-MM"
                :editable="false"
            ></date-picker>
          </div>
        </div>
        <template v-if="form.idModule && form.month">
          <div class="col-lg-2">
            <button class="btn btn-light-primary btn-block" @click="containers.showDetail = true;">
              Ver Programación
            </button>
          </div>
          <div class="col-lg-2">
            <button class="btn btn-light-primary btn-block" @click="containers.showProgramar = true;">
              Editar / Programar
            </button>
          </div>
        </template>
      </div>
      <DetailComponent v-if="containers.showDetail" :month="form.month" :idModule="form.idModule"/>
      <ProgramarComponent v-if="containers.showProgramar" :month="form.month" :idModule="form.idModule"/>
    </ui-card>
  </ui-content>
</template>
<script>

const DatePicker = () => import('vue2-datepicker');
import ProgramarComponent from '@/views/programacion/guias/ProgramarComponent.vue';
import DetailComponent from '@/views/programacion/guias/DetailComponent.vue';

export default {
  components: {
    DatePicker,
    ProgramarComponent,
    DetailComponent,
  },
  data() {
    return {
      form: {
        month: '',
        idModule: 1
      },
      containers: {
        showProgramar: false,
        showDetail: false
      }
    }
  },
  watch: {
    'form.idModule'() {
      this.containers.showProgramar = false;
      this.containers.showDetail = false;
    },
    'form.month'() {
      this.containers.showProgramar = false;
      this.containers.showDetail = false;
    },
    'containers.showProgramar'(newVal) {
      console.log('xd', newVal);
      if (newVal) {
        this.containers.showDetail = false;
      }
    },
    'containers.showDetail'(newVal) {
      if (newVal) {
        this.containers.showProgramar = false;
      }
    }
  }
};
</script>